<template>
  <FormulateInput 
    :value="value"
    :options="data"
    :placeholder="placeholder"
    type="select"
    aria-setsize=""
    :disabled="isDisabled"
    @change="change" />
</template>

<script>

export default {
  props: {
    value: {
      type: [Number, String],
      default: ''
    },
    options: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: ''
    },
    dataVariable: {
      type: String,
      default: ''
    },
    fromObj: {
      type: Object,
      default: () => {}
    },
    toObj: {
      type: Object,
      default: () => {}
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    data () {
      return this.dataVariable ? this[this.dataVariable] : this.options 
    },
    years () {
      let years = ["Year"]
      const currentYear = Number(new Date().getFullYear())
      for(var i = currentYear; i >= 2000; i--) {
        years.push(i)
      }
      return years
    },
    toYears () {
      const fromYears = [ ...this.years ]
      const temp = fromYears.filter((t) => t >= this.fromObj.year)
      return temp
    },
    toMonths () {
      const fromMonths = [ ...this.months ]
      const temp = fromMonths.filter((t) => t.value >= this.fromObj?.month)
      return this.fromObj?.year == this.toObj?.year ?  temp : this.months
    },
    months () {
      return [{
        label:  "Month",
        value: 0
      },
      {
        label: "January",
        value: 1
      },
      {
        label: "February",
        value: 2
      },
      {
        label: "March",
        value: 3
      },
      {
        label: "April",
        value: 4
      },
      {
        label: "May",
        value: 5
      },
      {
        label: "June",
        value: 6
      },
      {
        label: "July",
        value: 7
      },
      {
        label: "August",
        value: 8
      },
      {
        label: "September",
        value: 9
      },
      {
        label: "October",
        value: 10
      },
      {
        label: "November",
        value: 11
      },
      {
        label: "December",
        value: 12
      }]
    }
  },
  methods: {
    change (event) {
     this.$emit('input', Number(event.target.value))
     this.$emit('update')
    }
  }
}
</script>

<style scoped>

</style>